// import type { EducationQualification } from "@/types/lead";

export const QUALIFICATION_OPTIONS_UG = [
  { name: "Post-Graduate", value: 1 },
  { name: "Graduate", value: 3 },
  { name: "Polytechnic Diploma", value: 2 },
  { name: "Higher Secondary/ 10+2", value: 4 },
];

export const QUALIFICATION_OPTIONS_PG = [
  { name: "Post-Graduate", value: 1 },
  { name: "Graduate", value: 3 },
];

export enum LEAD_DROP_VARIANTS {
  LOGIN = "LOGIN",
  DOWNLOAD = "DOWNLOAD",
  REGISTER = "REGISTER",
}

export enum LEAD_DROP_STEPS {
  MOBILE_NUMBER = "MOBILE_NUMBER",
  OTHER_DETAILS = "OTHER_DETAILS",
  OTP_VERIFICATION = "OTP_VERIFICATION",
  OTP_VERIFIED = "OTP_VERIFIED",
  LAST_SCREEN = "LAST_SCREEN",
}

export enum USER_STATUS {
  NEW = "NEW",
  EXISTING = "EXISTING",
}

export const FORM_VALIDATION = {
  // Local part and domain are dot-separated atoms, so no leading, trailing or
  // repeated dots on either side, and the domain must end in an alphabetic TLD
  // of 2+ chars. The old `[^\s@]+\.[^\s@]+` domain check let junk like
  // "user@gmail.com......" or "user@gmail..com" through.
  EMAIL_REGEX:
    /^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/,
  PHONE_REGEX: /^[6-9]\d{9}$/,
  NAME_REGEX: /^[a-zA-Z]{3,}(?:\s+[a-zA-Z]+)*$/,
  ERROR_MESSAGES: {
    REQUIRED: (field: string) => `${field} is required`,
    INVALID_EMAIL: "Please enter a valid email",
    INVALID_PHONE: "Please enter a valid 10-digit phone number",
    INVALID_NAME: "Name must be at least 3 characters",
  },
};

export const PAGE_SOURCE = {
  LINK: "Link",
  DIRECT: "Direct",
  REF_TYPE: "ref",
};

export const THANK_YOU_SOURCE = {
  STORAGE_KEY: "thank_you_source",
  REFERRAL: "referral",
  INFLUENCER: "influencer",
} as const;

export const QUALIFICATION_OPTIONS = [
  "Post-Graduate",
  "Polytechnic Diploma",
  "Graduate",
  "Higher Secondary/ 10+2",
];

export const INVALID_ERP_CODE = "online - ba";

/** c1 marker written by lead drop variant 3 (direct DB insert; matches server LEAD_DROP_QUERY_DIRECT_C1). */
export const LEAD_DROP_TYPE_3_ERP_TAG = "Lead Drop 3";
